import React, { FC } from 'react'
import FilmStrip from 'components/SA/FilmStrip/FilmStrip'
import styles from './Homepage.module.scss'
import { IMAGE_URLS, STATS } from '../helpers'

const AnniversarySection: FC = () => {
  return (
    <div className={styles.anniversary}>
      <div className={styles.anniversaryStatsSection}>
        <div className={styles.stats}>
          {STATS.map(({ count, text }, index) => (
            <div className={styles.item} key={index}>
              <p className={styles.count}>{count}</p>
              <p className={styles.text}>{text}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default AnniversarySection
